import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { getDefaultRoute } from "../../config/routing";

const RedirectToHome = () => {

    const { officerProfile, officerPermissions } = useSelector((store) => {
        return {
            officerProfile: store.UserReducer.officerProfile,
            officerPermissions: store.UserReducer.officerPermissions,
        }
    });

    const officer = JSON.parse(sessionStorage.getItem("officer"));
    const isAuthenticated = JSON.parse(sessionStorage.getItem("isAuthenticated"));

    if (!isAuthenticated) return <Navigate to="/" replace />;

    return <Navigate to={getDefaultRoute(officerPermissions)} replace />;
};

export default RedirectToHome;